import { defineStore } from 'pinia';
import { CountryUtil, type Offer } from '@fibl/oxs-common';

export const useActivationOfferStore = defineStore('activationOffer', {
	state: () => ({
		activationResultsPerCountry: [] as Offer.ActivationResultsPerCountry[],
	}),

	getters: {},

	actions: {
		setActivationResultsPerCountry(
			activationResult: Offer.CheckOfferActivationResult[],
			country: CountryUtil.CountryCode,
		) {
			const resIndex = this.activationResultsPerCountry.findIndex(
				(res) => res.country === country,
			);
			if (resIndex === -1) {
				const result: Offer.ActivationResultsPerCountry = {
					country: 'DE',
					results: [],
				} as Offer.ActivationResultsPerCountry;
				result.country = country;
				activationResult.forEach((ar) => {
					result.results.push({
						invalidLinks: ar.invalidLinks,
						notFilledMandatoryFields: ar.notFilledMandatoryFields,
						offerId: ar.offerId,
					});
				});
				this.activationResultsPerCountry.push(result);
			} else {
				const result: Offer.ActivationResultsPerCountry['results'] = [];
				activationResult.forEach((ar) => {
					result.push({
						invalidLinks: ar.invalidLinks,
						notFilledMandatoryFields: ar.notFilledMandatoryFields,
						offerId: ar.offerId,
					});
				});
				this.activationResultsPerCountry[resIndex].results = result;
			}
			console.log('added: ', this.activationResultsPerCountry);
		},
	},
});
